const APIRequest = {
    POST: async function (data,  url) {
      return await fetch(url, {
        method: "POST",
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(data),
      })
        .then((responce) => {
          return responce.json();
        })
        .then((data) => {
          console.log(data);
          return data;
        })
        .catch((err) => {
          console.log("error" + err.message);
          return err.message;
        });
    },
    DELETE: async function (url) {
      return await fetch(url, {
        method: "DELETE",
      })
        .then((responce) => {
          return responce.json();
        })
        .then((data) => {
          console.log(data);
          return data;
        })
        .catch((err) => {
          console.log("error" + err.message);
          return err.message;
        });
    },
    PUT: async function (data, url) {
      return await fetch(url, {
        method: "PUT",
        body: data,
      })
        .then((responce) => {
          return responce.json();
        })
        .then((data) => {
          console.log(data);
          return data;
        })
        .catch((err) => {
          console.log("error" + err.message);
          return err.message;
        });
    },
    GET: async function (data, url) {
      const jwtToken = localStorage.getItem("openId");
      return await fetch(url, {
        mode: "cors",
        method: "GET",
        headers: { Authorization: `Bearer ${jwtToken}` },
      })
        .then((responce) => {
          return responce.json();
        })
        .then((data) => {
          console.log(data);
          return data;
        })
        .catch((err) => {
          console.log("error" + err.message);
          return err.message;
        });
    },
  };
  export default APIRequest;
  